import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'
import map from 'lodash/map'
import { MailgunEventTypeEnum } from '@ztechapps/common.contract'

const events = map(MailgunEventTypeEnum, (e) => {
  return e
})

export const fields: ListFieldConfig = {
  timeStamp: {
    name: 'timeStamp',
    type: ListFieldTypeEnum.dateTimeZone,
    excludeOnSearch: true,
    index: 2,
    size: 180,
  },
  subject: { name: 'subject', displayName: 'Subject', index: 1, size: 200 },
  bodyPlain: { name: 'bodyPlain', displayName: 'Body Plain', size: 400 },
  recipient: { name: 'recipient', displayName: 'Recipient', size: 300 },
  event: {
    name: 'event',
    displayName: 'Event',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: events,
    },
    size: 100,
  },
}
